import React, { FC } from 'react'
import styled from 'styled-components'
import { Animation } from 'ui/animation'

export type Props = {
  size?: 'medium' | 'small'
}

export const Loader: FC<Props> = ({ size = 'medium' }) => (
  <Animation type={'rotate-cw'} duration={1} infinite>
    <Spinner size={size} />
  </Animation>
)

const Spinner = styled.div<{ size: 'medium' | 'small' }>`
  content: '';
  z-index: 2;
  position: absolute;
  ${({ size, theme }) => {
    if (size === 'medium') {
      return `
        top: calc(50% - ${theme.spacing[3]});
        left: calc(50% - ${theme.spacing[3]});
        width: ${theme.spacing[6]};
        height: ${theme.spacing[6]};
    `
    } else {
      return `
        top: calc(50% - 0.6rem);
        left: calc(50% - 0.6rem);
        width: 1.2rem;
        height: 1.2rem;
      `
    }
  }}
  border: 0.36rem solid;
  border-left: 0.36rem solid transparent;
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.grey[700]};
`
